import {
	NATURAL_PERSON_CREATE_REQUESTING,
	NATURAL_PERSON_CREATE_SUCCESS,
	NATURAL_PERSON_CREATE_ERROR,
	NATURAL_PERSON_UPDATE_REQUESTING,
	NATURAL_PERSON_UPDATE_SUCCESS,
	NATURAL_PERSON_UPDATE_ERROR,
	NATURAL_PERSON_RESET_STATES,
	NATURAL_PERSON_FILL_DATA,
	NATURAL_PERSON_FILL_DATA_SUCCESS,
	NATURAL_PERSON_FILL_DATA_ERROR,
	NATURAL_PERSON_CLEAN_VALUES
} from './constants';

const initialState = {
	requesting: false,
	success: false,
	error: "",
	values: {},
	person: {}
};

const reducer = (state = initialState, action) => {
	switch (action.type){
		case NATURAL_PERSON_CREATE_REQUESTING:
		    return {
		   	    ...state,
		   	    requesting: false,
		   	    success: false,
		   	    error: ""
		    };
		case NATURAL_PERSON_CREATE_SUCCESS:
		    return {
		    	...state,
		    	requesting: false,
		    	success: true,
		    	error: "",
		    	person: action.person
		    };  
		case NATURAL_PERSON_CREATE_ERROR:
		    return {
		    	...state,
		    	requesting: false,
		    	success: false,
		    	error: action.error
		    };
		case NATURAL_PERSON_UPDATE_REQUESTING:
		    return {
		   	    ...state,
		   	    requesting: false,
		   	    success: false,
		   	    error: ""
		    };
		case NATURAL_PERSON_UPDATE_SUCCESS:
		    return {
		    	...state,
		    	requesting: false,
		    	success: true,
		    	error: "",
		    	person: action.person
		    };  
		case NATURAL_PERSON_UPDATE_ERROR:
		    return {
		    	...state,
		    	requesting: false,
		    	success: false,
		    	error: action.error
		    };  
		case NATURAL_PERSON_RESET_STATES:
		    return {
		    	...state,
                requesting: false,
                success: false,
                error: ""
		    };
		case NATURAL_PERSON_FILL_DATA:
		    return {
		    	...state,
		    	requesting: true,
		    	success: false,
		    	error: ""
		    };    
		case NATURAL_PERSON_FILL_DATA_SUCCESS:
		    return {
		    	...state,
		    	requesting: false,
		    	success: true,
		    	error: "",
		    	person: action.person
		    }; 
		case NATURAL_PERSON_FILL_DATA_ERROR:
		    return {
		    	...state,
		    	requesting: false,
		    	success: false,
		    	error: action.error
		    }; 
		case NATURAL_PERSON_CLEAN_VALUES:
		    return {
		    	...state,
		    	requesting: false,
		    	success: false,
		    	error: "",
		    	person: {},
		    	values: {}
		    };  
		default: 
		    return state;      
	}
}

export default reducer;